import { render, staticRenderFns } from "./FoHeader.vue?vue&type=template&id=323c83c8&scoped=true&"
import script from "./FoHeader.vue?vue&type=script&lang=js&"
export * from "./FoHeader.vue?vue&type=script&lang=js&"
import style0 from "./FoHeader.vue?vue&type=style&index=0&id=323c83c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c83c8",
  null
  
)

export default component.exports